import React from 'react'
import reactStamp from 'react-stamp'

import './home.css'

export default reactStamp(React).compose({

    render() {
        if (this.props.practitioner.name != undefined) {
            let classNames = '';

            if (this.props.single) {
                classNames = "office-card-container single-info";
            } else {
                classNames = "office-card-container";
            }
            return (
                <div className={classNames}>
                    <h2 className="home-office-card-name-label">Office Location</h2>
                    <p className="info-label">{this.props.practitioner.address.city}</p>
                    <p className="info-label">{this.props.practitioner.address.line}</p>
                    <p className="info-label">{this.props.practitioner.address.state || this.props.practitioner.address.country
                    + ", " + this.props.practitioner.address.postalCode}</p>
                    <p className="info-label">{this.props.practitioner.email}</p>
                    <p className="info-label">{this.props.practitioner.phone}</p>
                </div>
            )
        } else {
            return null;
        }
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Home/HomeOfficeCard.js
 **/